<template>
  <div class="row mb-2">
    <div v-for="(person, index) in personen" :key="index" class="col-xl-6 px-3">
      <div class="form-group mb-0">
        <span
          v-if="editable && index == 0"
          v-on:click="addPerson()"
          class="multiAddIcon"
        >
          <font-awesome-icon icon="fa-regular fa-plus" />
        </span>
        <span
          v-if="editable && index > 0"
          class="multiAddIcon"
          v-on:click="removePerson(index)"
          ><font-awesome-icon icon="fa-regular fa-minus" />
        </span>
        <span
          v-if="editable"
          class="editIcon"
          v-on:click="oeffneGPSucheModal(index)"
          ><font-awesome-icon icon="fa-duotone fa-pencil-alt" />
        </span>
        <span class="openIcon" v-on:click="openPerson(person.id)" v-if="open"
          ><font-awesome-icon icon="fa-duotone fa-arrow-circle-right" />
        </span>
        <input v-model="person.personName" class="form-control" readonly />
        <label v-if="index == 0"
          >{{ label }}
          <!--<font-awesome-icon icon="fa-duotone fa-arrow-circle-right" />-->
        </label>
      </div>
    </div>

    <gpSucheModal
      id="geschaeftspartner-suche-modal"
      :filterRollen="rollen"
      @confirmed="onGPResult"
    ></gpSucheModal>
  </div>
</template>

<script>
import gpSucheModal from "@/components/Geschaeftspartner/gpSucheModal";
import { textNotLinked } from "@/defaultTexts.js";

export default {
  name: "MultiSelectPerson",
  components: { gpSucheModal },
  props: {
    personen: {
      type: Array,
      default: function () {
        return [{ personName: textNotLinked }];
      },
    },
    label: {
      type: String,
      default: "Verantwortliche",
    },
    rollen: {
      type: Array,
      required: false,
    },
    open: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      editPerson: null,
    };
  },
  methods: {
    oeffneGPSucheModal(index) {
      this.editPerson = index;
      this.$bus.$emit(
        "openGeschaeftspartnerModal",
        "geschaeftspartner-suche-modal"
      );
    },
    onGPResult(selectedPerson) {
      if (selectedPerson) {
        let tempListe = this.personen;
        this.$set(tempListe, this.editPerson, selectedPerson[0]);
      }
      this.$emit("confirmed", this.personen);
    },
    addPerson() {
      if (this.personen.length < 6) {
        let tempListe = this.personen;
        tempListe.push({ personName: textNotLinked });
      }
    },
    removePerson(index) {
      let tempListe = this.personen;
      tempListe.length == 0
        ? { personName: textNotLinked }
        : tempListe.splice(index, 1);

      this.$emit("confirmed", this.personen);
    },
    openPerson(id) {
      if (id) {
        this.$router.push({
          name: "geschaeftspartner",
          params: { id: id, anzeige: 0 },
        });
      }
    },
  },
};
</script>
